/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const ModerationStatus = {
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected'
};
export function ModerationStatusFromJSON(json) {
    return ModerationStatusFromJSONTyped(json, false);
}
export function ModerationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ModerationStatusToJSON(value) {
    return value;
}
